import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventItem, League, Lookups} from "@model";

export enum LeagueEventTableType {
  EVENT,
  TEMPLATE,
  PENDING
}

@Component({
  selector: 'app-league-events-table',
  templateUrl: './league-events-table.component.html',
  styleUrl: './league-events-table.component.scss',
  standalone: false
})
export class LeagueEventsTableComponent implements OnInit {
  @Input() events: EventItem[] = [];
  @Input() league: League | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() showDropdown: boolean = true;
  @Input() allExpanded: boolean = false;
  @Input() disableEditing: boolean = true;
  @Input() type: LeagueEventTableType = LeagueEventTableType.EVENT;

  @Output() onRemove = new EventEmitter<{id: number, isRace: boolean}>();
  @Output() onOpenDetails = new EventEmitter<EventItem>();
  @Output() onChangeEventType = new EventEmitter<EventItem>();
  @Output() onOpenShortName = new EventEmitter<EventItem>();

  expandedEventIds = new Set<number>();
  isTemplate = false;
  isEvent = false;
  isPending = false;
  showRaces = false;
  showOrganizerName = false;
  showDetailsDropdownAction = false;
  showAddShortNameDropdownAction = false;
  showChangeEventTypeDropdownAction = false;
  showRound = false;
  showType = false;
  eventValidityMap = new Map<number, boolean>();


  protected readonly LeagueEventTableType = LeagueEventTableType;

  ngOnInit() {
    this.isTemplate = this.type === LeagueEventTableType.TEMPLATE;
    this.isEvent = this.type === LeagueEventTableType.EVENT;
    this.isPending = this.type === LeagueEventTableType.PENDING;
    this.showRaces = !this.isTemplate;
    this.showOrganizerName = !this.isTemplate;
    this.showDetailsDropdownAction = this.isTemplate;
    this.showAddShortNameDropdownAction = !this.isTemplate;
    this.showRound = !this.isPending && !!this.league?.roundsEnabled;
    this.showType = !this.isPending;
    this.showChangeEventTypeDropdownAction = !this.isPending

    if (this.allExpanded) {
      this.events.forEach(e => this.expandedEventIds.add(e.id!));
    }

    const leagueStart = this.league?.start ? new Date(this.league.start) : null;
    const leagueEnd = this.league?.end ? new Date(this.league.end) : null;

    this.eventValidityMap = new Map(
        [...(this.events ?? [])]
            .map(e => {
              const start = e.start ? new Date(e.start) : null;
              const end = e.end ? new Date(e.end) : null;
              const valid = !(start && leagueStart && start < leagueStart) &&
                  !(end && leagueEnd && end > leagueEnd);
              return [e.id!, valid];
            })
    );
  }

  toggleEvent(eventId: number): void {
    this.expandedEventIds.has(eventId)
        ? this.expandedEventIds.delete(eventId)
        : this.expandedEventIds.add(eventId);
  }

  onRemoveClick(id: number, isRace: boolean = false) {
    this.onRemove.emit({id, isRace});
  }

  onDetailsClick(event: EventItem) {
    this.onOpenDetails.emit(event);
  }

  onChangeTypeClick(event: EventItem) {
    this.onChangeEventType.emit(event);
  }

  onOpenShortNameModal(event: EventItem) {
    this.onOpenShortName.emit(event);
  }

  readonly statusClassMap: Record<number, string> = {
    0: 'denied', 1: 'accepted', 2: 'publishing', 3: 'blue', 4: 'denied', 5: 'on-hold', 8: 'denied'
  };
  readonly templateStatusClassMap: Record<number, string> = {
    1: 'accepted', 2: 'publishing', 3: 'blue', 4: 'denied'
  };

  readonly typeClassMap: Record<number, string> = {
    1: 'blue', 2: 'orange'
  };

}
